
import axios, { AxiosRequestConfig } from 'axios';
import { CommonAxiosServiceWp } from './common-axios-service-wp';
import { BroadcastMessageRequest, BroadcastSummaryResponse, CommonResponse, CompanyIdDateRangeRequest, ExcelImportModel, ExcelImportResponse, GlobalResponseObject, MessageRequest } from '@schemax-whatsapp/shared-models';

export class MessageBroadcastService extends CommonAxiosServiceWp {

  private getURLwithMainEndPoint(childUrl: string) {
    return '/message-broadcast/' + childUrl;
  }

  async sendMessage(request: MessageRequest, config?: AxiosRequestConfig): Promise<GlobalResponseObject> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('sendMessage'), request, config);
  }

  async saveBroadCastedMessageToMultipleCustomers(request: BroadcastMessageRequest, config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('saveBroadCastedMessageToMultipleCustomers'), request, config);
  }

  async getBroadCastSummaryStatusForCompany(companyIdReq: CompanyIdDateRangeRequest, config?: AxiosRequestConfig): Promise<BroadcastSummaryResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('getBroadCastSummaryStatusForCompany'), companyIdReq, config);
  }

  async messagePhotoUpload(file: any, config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('messagePhotoUpload'), file, config);
  }

  async createTemplate(request: BroadcastMessageRequest, config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('createTemplate'),request,config);
  }  
}



